import React from "react";
import TableCell, { TableCellProps } from "@mui/material/TableCell";
import "./styles.scss";

const classNameBase = "scd-table-light-cell";
export default function CellTableLight({
  children,
  align,
  className,
}: TableCellProps): React.JSX.Element {
  return (
    <TableCell
      padding="none"
      align={align}
      className={className}
      classes={{
        root: `${classNameBase}-root`,
        head: `${classNameBase}-head`,
      }}
    >
      {children}
    </TableCell>
  );
}
